import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import { BiClipboard, BiCog, BiHeadphone } from 'react-icons/bi';

const STEP_ICONS = [BiClipboard, BiCog, BiHeadphone];

const ManagedServicesProcess = () => {
  const { t } = useTranslations();
  const steps = [1, 2, 3].map((n, index) => ({
    title: t(`managedServices_process_step${n}_title`),
    desc: t(`managedServices_process_step${n}_desc`),
    icon: STEP_ICONS[index],
    stepLabel: `${t('managedServices_process_step_prefix')} ${n}`,
  }));

  return (
    <section className="ms-section ms-section--alt ms-section--process-overview">
      <div className="container">
        <div className="ms-section-header ms-section-header--center">
          <span className="ms-section__badge">{t('managedServices_process_badge')}</span>
          <h2 className="ms-section__title">{t('managedServices_process_title')}</h2>
          <p className="ms-section__lead ms-section__lead--center">
            {t('managedServices_process_subtitle')}
          </p>
        </div>
        <div className="ms-process-timeline" role="list">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="ms-process-timeline__item" role="listitem">
                <div className="ms-process-timeline__node-wrap">
                  <div className="ms-process-timeline__node">
                    <span className="ms-process-timeline__num" aria-hidden>{index + 1}</span>
                    <Icon className="ms-process-timeline__icon" aria-hidden />
                  </div>
                </div>
                <div className="ms-process-timeline__card">
                  <span className="ms-process-timeline__step">{step.stepLabel}</span>
                  <h4>{step.title}</h4>
                  <p>{step.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ManagedServicesProcess;
